(function () {
    'use strict';

    angular
        .module('app')
        .directive('simpleTextBlock', simpleTextBlock);

    simpleTextBlock.$inject = ['$window'];

    function simpleTextBlock($window) {
        // Usage:
        //     <searchPop></searchPop>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $(document).ready(function () {
                //get child nodes of div.simpletextblock
                var simpleTextDiv = $('div.block.simpletextblock');
                var children = simpleTextDiv.children();
                simpleTextDiv.parent().prepend(children);
                simpleTextDiv.remove();
            });
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./Views/Blocks/SimpleTextBlock/_simpleTextBlock.js
// module id = 28
// module chunks = 0